<app-mobile-info-header *ngIf="checkDeviceService.shouldShowBanner$ | async"></app-mobile-info-header>
<div [ngClass]="{ 'mobile-container': checkDeviceService.shouldShowBanner$ | async }">
  <app-gallery-modal></app-gallery-modal>
  <app-loading-spinner [showSpinner]="isLoading$ | async">
    <router-outlet></router-outlet>
  </app-loading-spinner>
</div>
